/**
 * Cart drawer (snippets/cart-drawer.liquid).
 *
 * Below 750px the drawer is a bottom sheet (gh-cart.css). Like the size guide and the filter
 * drawer, it closes by dragging its top edge (grabber and header) down: past a quarter of its
 * height, or with a quick flick, it closes; otherwise it springs back.
 * Listeners sit on the document, so they survive Horizon re-rendering the drawer on cart changes.
 */
const GRAB_AREA = 48;
const DRAG_CLOSE_RATIO = 0.25;
const mobileQuery = window.matchMedia('(max-width: 749px)');

/** @type {{ panel: HTMLDialogElement, startY: number, startTime: number, offset: number, pointerId: number } | null} */
let drag = null;

/** @param {PointerEvent} event */
function onPointerDown(event) {
  if (!mobileQuery.matches || event.button !== 0 || !(event.target instanceof Element)) return;

  const panel = event.target.closest('#cart-drawer .theme-drawer__dialog');
  if (!(panel instanceof HTMLDialogElement) || !panel.open) return;

  // Buttons in the header (close) keep working; the rest of the header is part of the grabber
  if (event.target.closest('button, a, input, textarea')) return;

  const inHeader = event.target.closest('.theme-drawer__header') !== null;
  if (!inHeader && event.clientY - panel.getBoundingClientRect().top > GRAB_AREA) return;

  drag = { panel, startY: event.clientY, startTime: event.timeStamp, offset: 0, pointerId: event.pointerId };
  panel.classList.add('is-dragging');
  panel.setPointerCapture(event.pointerId);
  panel.addEventListener('pointermove', onPointerMove);
  panel.addEventListener('pointerup', onPointerUp);
  panel.addEventListener('pointercancel', onPointerUp);
}

/** @param {PointerEvent} event */
function onPointerMove(event) {
  if (!drag) return;
  drag.offset = Math.max(0, event.clientY - drag.startY);
  drag.panel.style.translate = `0 ${drag.offset}px`;
}

/** @param {PointerEvent} event */
function onPointerUp(event) {
  if (!drag) return;
  const { panel, offset, startTime, pointerId } = drag;
  drag = null;

  panel.removeEventListener('pointermove', onPointerMove);
  panel.removeEventListener('pointerup', onPointerUp);
  panel.removeEventListener('pointercancel', onPointerUp);
  if (panel.hasPointerCapture(pointerId)) panel.releasePointerCapture(pointerId);
  panel.classList.remove('is-dragging');

  const velocity = offset / Math.max(event.timeStamp - startTime, 1);
  const shouldClose = offset > panel.offsetHeight * DRAG_CLOSE_RATIO || (offset > 40 && velocity > 0.5);

  if (shouldClose) {
    const drawer = document.getElementById('cart-drawer');
    panel.addEventListener('close', () => panel.style.removeProperty('translate'), { once: true });
    if (drawer && 'close' in drawer && typeof drawer.close === 'function') drawer.close();
  } else {
    panel.style.removeProperty('translate');
  }
}

document.addEventListener('pointerdown', onPointerDown);
